<template>
    <div class="u-mt-20" style="padding: 20px 12px;">
        <h4>Rematrícula</h4>
        <p class="pa-sub">Solicitação de vaga para o próximo período letivo.</p>

        <div v-if="loading" class="pa-loading"><img src="/public/img/loading-bar.gif" /></div>

        <template v-else>
            <el-alert v-if="erro" type="warning" :closable="false" show-icon :title="erro" class="u-mb-10" />

            <!-- Quem decide se está aberta é o BACKEND. O portal só apresenta. -->
            <el-alert v-if="!opcoes.aberta" type="info" :closable="false" show-icon
                      :title="opcoes.motivo || 'A solicitação de rematrícula não está disponível no momento.'"
                      class="u-mb-10">
                <template v-if="opcoes.prazo">
                    <div class="pa-menor">Prazo informado pela escola: {{ opcoes.prazo }}</div>
                </template>
            </el-alert>

            <div v-else class="card-form u-mb-10">
                <div class="pa-menor u-mb-10">Escola: <strong>{{ opcoes.escola || '—' }}</strong></div>

                <el-form label-position="top" size="mini">
                    <el-form-item label="Curso desejado">
                        <el-select v-model="form.curso_id" placeholder="Selecione" style="width:100%" clearable>
                            <el-option v-for="c in opcoes.cursos" :key="c.id" :value="c.id" :label="c.nome" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="Observação (opcional)">
                        <el-input type="textarea" :rows="3" v-model="form.observacao"
                                  maxlength="1000" show-word-limit
                                  placeholder="Alguma informação que a escola deva saber" />
                    </el-form-item>

                    <div class="u-text-right">
                        <el-button type="primary" size="mini" :loading="enviando"
                                   :disabled="!form.curso_id" @click="solicitar">
                            Enviar solicitação
                        </el-button>
                    </div>
                </el-form>
            </div>

            <h5>Minhas solicitações</h5>

            <div v-if="solicitacoes.length === 0" class="pa-vazio">
                Você ainda não fez nenhuma solicitação.
            </div>

            <el-table v-else :data="solicitacoes" size="mini" stripe style="width:100%">
                <el-table-column label="Data" width="100">
                    <template slot-scope="s">{{ formatarData(s.row.data_solicitacao) }}</template>
                </el-table-column>
                <el-table-column label="Curso" min-width="140">
                    <template slot-scope="s">{{ s.row.curso || '—' }}</template>
                </el-table-column>
                <el-table-column label="Situação" width="120">
                    <template slot-scope="s">
                        <el-tag size="mini" :type="corStatus(s.row.status)">{{ s.row.status }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="Resposta da escola" min-width="160" class-name="hidden-mobile">
                    <template slot-scope="s">{{ s.row.resposta || '—' }}</template>
                </el-table-column>
            </el-table>
        </template>
    </div>
</template>

<script>
/**
 * BLOCO N — item 2.
 *
 * O portal envia APENAS `curso_id` e `observacao`. Aluno, instituição, período e status
 * são resolvidos pelo backend a partir da matrícula do token — enviá-los aqui não teria
 * efeito, e o gate de escopo prova isso.
 *
 * A janela de rematrícula é decidida pelo backend (`opcoes.aberta`); o Vue não conhece
 * regra de prazo.
 */
export default {
    name: 'PortalRematricula',

    data: () => ({
        loading: true, enviando: false, erro: null,
        opcoes: { aberta: false }, solicitacoes: [],
        form: { curso_id: '', observacao: '' }
    }),

    mounted () { this.carregar() },

    methods: {
        carregar () {
            this.loading = true
            this.erro = null

            const cfg = this.$store.getters.getHeaderAuth
            const base = this.$store.state.config.baseUrlApi

            Promise.all([
                this.$axios.post(`${base}/api/portal/rematricula/opcoes`, {}, cfg),
                this.$axios.post(`${base}/api/portal/rematricula/minhas`, {}, cfg)
            ]).then(([o, m]) => {

                this.loading = false

                if (o.data && o.data.erro) { this.erro = o.data.erro; return }

                this.opcoes = o.data || { aberta: false }
                this.solicitacoes = (m.data && m.data.solicitacoes) || []

            }).catch(() => {
                this.loading = false
                this.erro = 'Não foi possível carregar a rematrícula.'
            })
        },

        solicitar () {
            this.enviando = true

            // Whitelist do lado do cliente também: só o que o backend aceita.
            const payload = { curso_id: this.form.curso_id, observacao: this.form.observacao }

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/rematricula/solicitar`,
                             payload, this.$store.getters.getHeaderAuth).then(r => {

                this.enviando = false
                const d = r.data || {}

                // Só anuncia sucesso depois de LER a resposta.
                if (d.erro) {
                    window.eventBus.$emit('alert', { msg: d.erro, type: 'warning' })
                    return
                }

                window.eventBus.$emit('alert', { msg: d.mensagem || 'Solicitação registrada.', type: 'success' })
                this.form.observacao = ''
                this.carregar()

            }).catch(() => {
                this.enviando = false
                window.eventBus.$emit('alert', { msg: 'Não foi possível enviar a solicitação.', type: 'warning' })
            })
        },

        formatarData (d) {
            if (!d) return '—'
            const p = String(d).substring(0, 10).split('-')
            return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : d
        },

        corStatus (s) {
            const t = String(s || '').toLowerCase()
            if (t.indexOf('defer') === 0) return 'success'
            if (t.indexOf('indefer') === 0) return 'danger'
            if (t.indexOf('análise') >= 0 || t.indexOf('analise') >= 0) return 'warning'
            return 'info'
        }
    }
}
</script>

<style scoped>
.pa-loading { min-height: 300px; display: flex; justify-content: center; align-items: center; }
.pa-sub { color: #909399; }
.pa-menor { color: #909399; font-size: 12px; }
.pa-vazio { padding: 22px 12px; text-align: center; color: #909399; background: #fafafa; border-radius: 4px; }
.card-form { border: 1px solid #ebeef5; border-radius: 4px; padding: 12px; }
@media (max-width: 640px) { .hidden-mobile { display: none !important; } }
</style>
